<!-- @format -->
<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import { getStoresContext } from "~/stores";
  import type { StoresKey } from "~/stores";
  import { todaysOpeningHoursItem } from "~/util/date-n-time";
  import OpeningHoursRange from "@components/opening-hours/OpeningHoursRange.svelte";
  import { displayFloor } from "../store/utils";

  export let request_store_key: StoresKey;
  export let store: ManageAPI.Store;
  export let href: string;
  export let show_fob = true

  let status: ManageAPI.OpeningStatus | undefined = undefined;
  const { locale, scdata, site, T } = getStoresContext(request_store_key);

  $: fob_desc = $scdata.fieldsOfBusiness.find(
    (fob) => fob.id == store.fieldOfBusinessId
  )?.description;

  $: floor_desc = displayFloor(store, $T);
  $: office_tower_info = store.floor?.officeTower;

  $: t = $T;
  $: hours_today = todaysOpeningHoursItem(store);
  $: closed = (status === 'CLOSED') || (status === 'TEMPORARY_CLOSED');
</script>

{#if $site}
  <a class="store-card" class:closed {href}>
    <h4 class="store-name">{store.name}</h4>
    <p class="fob-floor">
      {#if fob_desc && show_fob}
        <span class="floor d-block d-sm-inline">{fob_desc}</span>
        {#if floor_desc}
          <span class="mx-sm-1 mx-2 d-sm-inline d-none">&#x2022;</span>
        {/if}
      {/if}
      {#if office_tower_info}
        <span class="mb-2">{office_tower_info.name}</span>
      {:else if floor_desc}
        <span class="mb-2">{floor_desc}</span>
      {/if}
    </p>

    {#if hours_today}
      <p class="mb-2 open-today">
        {t`today`}: <strong>
          <OpeningHoursRange 
            locale={$locale} 
            item={hours_today} 
            opening_hours={store.unformattedOpeningHours}
            {t} 
            bind:status
          />
        </strong>
      </p>
    {/if}
  </a>
{/if}

<style lang="scss">
  a {
    color: var(--color-black);
  }
  a:hover {
    text-decoration: none;
    .store-name {
      text-decoration: underline;
    }
  }

  .store-name {
    font-size: 18px;
    font-weight: 500;
    @media screen and (min-width: 576px) {
      font-size: 24px;
    }
  }
  
  .open-today,
  .fob-floor {
    font-size: 14px;
    @media screen and (min-width: 576px) {
      font-size: 16px;
    }
  }

  .open-today {
    font-variant-numeric: tabular-nums;
  }

  .closed {
    opacity: 0.4;
  }
</style>
